import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnGetCategories(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 'invalid':
            message = 'Ops! É preciso preencher todos os campos.'
            break
        case '2xx':
            message = 'A lista de categorias foi atualizada com sucesso.'
            break
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos listar as categorias.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não listamos as categorias. Por favor, tente novamente mais tarde.'
    }
    return message
}
